/** Horizontal single-series bars: ≤ 12px thick, rounded data end, value at the tip. */
export function HBars({
  items,
  color,
  format,
  max,
}: {
  items: { label: string; value: number; note?: string }[];
  color: string;
  format: (v: number) => string;
  max?: number;
}) {
  const top = max ?? Math.max(...items.map((i) => i.value), 1e-9);
  return (
    <ul className="hbars">
      {items.map((it) => (
        <li key={it.label} title={it.note}>
          <span className="hbar-label">{it.label}</span>
          <span className="hbar-track">
            <span className="hbar-fill" style={{ width: `${Math.max(1.5, (it.value / top) * 100)}%`, background: color }} />
          </span>
          <span className="hbar-value">{format(it.value)}</span>
        </li>
      ))}
    </ul>
  );
}
